import React from "react";
import Navigation from "../../organisms/Navigation/Navigation";
import Footer from "../../organisms/Footer/Footer";
import AboutBanner from "../../molecules/AboutBanner/AboutBanner";
import AboutNewsletter from "../../molecules/AboutNewsletter/AboutNewsletter";
import StoreIntegration from "../../molecules/AboutStoreIntegration/AboutStoreIntegration";
const About = () => {
  return (
    <div>
      <Navigation />

      <AboutBanner />

      <StoreIntegration />
      
      <AboutNewsletter />


      <Footer />
    </div>
  );
};

export default About;
